module.exports = __webpack_public_path__ + "media/images/proof_links/youtube-6063fbcb5788f31641ca74b1451de5a0.svg";